<footer class="bg-indigo-700 pt-8 pb-6 bg-opacity-50">
  <div class="container mx-auto px-4">
    <div class="flex flex-wrap">
      <div class="w-full lg:w-6/12 px-4">
        <h4 class="text-3xl font-semibold">Let's keep in touch!</h4>
        <h5 class="text-lg mt-0 mb-2 text-gray-100">
          Find us on any of these platforms
        </h5>
        <div class="mt-6">
          <button
            class="text-blue-400 mr-4 outline-none"
            type="button"
            (click)="goToUrl('https://twitter.com/RemitFree')"
          >
            <i class="flex fab fa-twitter fa-2x"></i>
          </button>
          <button
            class="text-blue-600 mr-4 outline-none"
            type="button"
            (click)="goToUrl('https://www.facebook.com/remitfree')"
          >
            <i class="flex fab fa-facebook-square fa-2x outline-none"></i>
          </button>
          <button
            class="text-pink-600 mr-4 outline-none"
            type="button"
            (click)="goToUrl('https://www.instagram.com/remitfree')"
          >
            <i class="flex fab fa-instagram fa-2x"></i>
          </button>
          <button
            class="text-red-600 mr-4 outline-none"
            type="button"
            (click)="sendMail()"
          >
            <i class="flex far fa-envelope fa-2x"></i>
          </button>
        </div>
      </div>
      <div class="w-full lg:w-6/12 px-4">
        <div class="flex flex-wrap items-top mb-6">
          <div class="w-full lg:w-4/12 px-4 ml-auto">
            <span
              class="block uppercase text-gray-200 text-sm font-semibold mb-2"
              >Useful Links</span
            >
            <ul class="list-unstyled">
              <li>
                <a
                  class="text-gray-200 hover:text-gray-300 font-semibold block pb-2 text-sm"
                  routerLink="/"
                  >Home</a
                >
              </li>
              <li>
                <a
                  class="text-gray-200 hover:text-gray-300 font-semibold block pb-2 text-sm"
                  routerLink="/about"
                  >About Us</a
                >
              </li>
            </ul>
          </div>
          <div class="w-full lg:w-4/12 px-4">
            <span
              class="block uppercase text-gray-100 text-sm font-semibold mb-2"
              >Other Resources</span
            >
            <ul class="list-unstyled">
              <li>
                <a
                  class="text-gray-100 hover:text-gray-300 font-semibold block pb-2 text-sm"
                  href="#"
                  >Terms &amp; Conditions</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div
      class="flex flex-wrap items-center md:justify-between justify-center mt-10"
    >
      <div class="w-full md:w-4/12 px-4 mx-auto text-center">
        <div class="text-sm text-gray-100 font-semibold py-1">
          Copyright © {{ date }} Remitfree
        </div>
      </div>
    </div>
  </div>
</footer>
